import { AiOutlineLeft } from "react-icons/ai";
import goTo from "../../../controllers/goTo";
import CustomButton from "../../helperComponents/CustomButton";
import CornerProfileButton from "./CornerProfileButton";
import styled from "styled-components";
import { FaArrowLeft } from "react-icons/fa";

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 0;
  width: 100%;
  margin-bottom: 20px;
`;

const Left = styled.div`
  display: flex;
  flex-direction: row;
  gap: 25px;
  align-items: center;
  animation: centerScaleReveal 0.4s ease-in-out forwards;
`;

const Title = styled.div`
  display: flex;
  gap: 5px;
  flex-direction: column;
`;

const SecondaryTitle = styled.span`
  font-size: 14px;
  /* color: var(--elementDim); */
  text-transform: capitalize;
  opacity: 0.6;
  font-weight: 600;
  color: var(--accent);
`;

const PrimaryTitle = styled.span`
  font-size: 20px;
  color: var(--accent);
  font-weight: 600;
  text-transform: capitalize;
`;

const Right = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const BackButton = styled.div`
  height: 50px;
  padding: 0 30px;
  background-color: transparent;
  color: var(--elementDim);
  border: 1px solid var(--border);
  border-radius: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  &:hover {
    background: var(--surface3);
  }
`;

export default function LoggedInTopBar({
  showBackButton = false,
  titleLine1,
  titleLine2,
  rightSlot,
}) {
  return (
    <Container>
      <Left>
        {showBackButton ? (
          <BackButton onClick={goTo(-1)}>
            <FaArrowLeft />
          </BackButton>
        ) : null}

        <Title>
          <SecondaryTitle>{titleLine1}</SecondaryTitle>
          <PrimaryTitle>{titleLine2}</PrimaryTitle>
        </Title>
      </Left>

      <Right>
        {rightSlot}
        <CornerProfileButton />
      </Right>
    </Container>
  );
}
